import { GatsbyImage } from "gatsby-plugin-image";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Slide } from "react-slideshow-image";

import * as styles from "../styles/SlideShow.module.css";
import PageIndicator from "./PageIndicator";

export interface SSImageData {
  image: string;
  link: string;
}
export interface SlideShowProps {
  images: [SSImageData];
  piBottom?: Boolean;
  smallArrows?: Boolean;
}

const SlideShow = (props: SlideShowProps) => {
  const slideRef = useRef<Slide>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoplay, setAutoplay] = useState(true);

  useEffect(() => {
    setAutoplay(props.images.length > 1);
  }, [props.images]);

  const onPageChange = React.useCallback(
    (_, n) => {
      setCurrentSlide(n);
    },
    [props.images, slideRef]
  );

  const onPageSelected = useCallback(
    (i) => {
      slideRef.current?.goTo(i);
    },
    [slideRef]
  );


  return (
    <div className={styles.ss_outer}>
      <div className={styles.slide_show_container}>
        <Slide
          ref={slideRef}
          autoplay={autoplay}
          canSwipe={autoplay}
          arrows={false}
          onChange={onPageChange}
        >
          {props.images.map((e: any, i) => (
            <div
              key={`ssimge_${i}`}
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                href={e.link}
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  paddingLeft: 20,
                  paddingRight: 20,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <GatsbyImage
                  key={i}
                  image={e.img != null ? e.img : e}
                  className={styles.slide_show_img}
                  alt={e.alt != null ? e.alt : e}
                />
              </a>
            </div>
          ))}
        </Slide>
      </div>
      <div
        className={styles.pi_container}
        style={props.piBottom ? { top: 0, bottom: 0 } : {}}
      >
        <PageIndicator
          currentPage={currentSlide}
          count={props.images.length}
          style={{ marginTop: 0 }}
          onClick={onPageSelected}
        />
      </div>
    </div>
  );
};



export default SlideShow;
